<template>
  <section class="hero bg-image is-fullheight is-fullheight-with-navbar" id="home">
    <div class="hero has-overlay is-fullheight is-fullheight-with-navbar">
      <div class="hero-body">
        <div class="container">
          <div class="column has-text-centered">
            <transition name="fade">
              <picture v-if="show">
                <source :srcset="logo.newImageFormat" type="image/webp">
                <img class="logo" :src="logo.traditionalImageFormat" :alt="logo.alt">
              </picture>
            </transition>
            <transition name="fade-tag">
              <div
                v-if="show"
                class="tag-line is-size-2 is-size-3-mobile is-size-1-tablet has-text-white-ter has-text-right"
              >
                We make things
                <span style="color: #24A986">easier.</span>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'DropPage',
  data () {
    return {
      show: false,
      logo: {
        traditionalImageFormat: require('@/assets/logo-white.png'),
        newImageFormat: require('@/assets/logo-white.webp'),
        alt: 'Codeasy logo',
      },
    }
  },
  mounted () {
    setTimeout(() => {
      this.show = true
    }, 2000)
  },
}
</script>

<style lang="scss" scoped>
@import "~bulma";

.logo {
  max-width: 50%;
  @include mobile {
    max-width: 100%;
  }
  @include tablet-only {
    max-width: 80%;
  }
}

.tag-line {
  margin-right: 25%;
  @include tablet-only {
    margin-right: 15%;
  }
  @include mobile {
    margin-right: 0;
  }
  // @include small-mobile {
  //   font-size: 1.75rem !important;
  // }
}

.bg-image {
  background: black url("../assets/images/primary-background.jpg") center / cover;
}

.has-overlay {
  background-color: rgba(0, 0, 0, 0.75);
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1.5s;
}
.fade-tag-enter-active,
.fade-tag-leave-active {
  transition: opacity 5s;
}

.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.fade-tag-enter, .fade-tag-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
